<template>
    <div class="home">
        <b-row>
            <b-col cols="12">
                <b-button @click="printCertificate()" variant="success" class="mr-3 mt-1">
                    Print Certificate
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import axios from 'axios'
    import * as FileSaver from 'file-saver'
    export default {
        name: "PrintCertificateButton",

        methods:{
            printCertificate(){
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/certificate/generate`)
                    .then(response => {
                        const file = response.data;
                        if (file.contentType == null){
                            return;
                        }
                        const byteString = atob(file.fileData); //deprecated, update later
                        const arrayBuffer = new ArrayBuffer(byteString.length);
                        const int8Array = new Uint8Array(arrayBuffer);
                        for(let i=0;i<byteString.length;i++){
                            int8Array[i] = byteString.charCodeAt(i);
                        }
                        const blob = new Blob([int8Array], {type: file.contentType});
                        FileSaver.saveAs(blob, file.name);
                    })
            },
        },
        created() {
            document.title = 'Print Certificate';
        },
    }


</script>

<style scoped>

</style>